/**
 * 【KYMW1404】掲載候補商品リスト検索条件
 *
 * @export NominationGoodsSearchConditionModel
 * @class NominationGoodsSearchConditionModel
 */
export class NominationGoodsSearchConditionModel {
  private readonly DEFAULT_ORDER_GOODS_FLG = '01';
  private readonly DEFAULT_FORM_ID = 'KYMW1404';

  /**
   * 画面ID
   */
  public formID = this.DEFAULT_FORM_ID;

  /**
   * 受注コード
   */
  public orderCode = '';

  /**
   * 媒体区分
   */
  public mediumType = '';

  /**
   * 生協コード
   */
  public coopCode = '';

  /**
   *  ページ番号
   */
  public pageNum = '';

  /**
   *  売り場コード
   */
  public sellAreaCode = '';

  /**
   * 部門コード
   */
  public classCode = '';

  // 注文コード割当条件追加対応
  public orderNumQuota = '';

  /**
   * 部門コード配列
   */
  public classCodeArray: string[] = [];

  /**
   * Ｗ掲載予定のみフラグ
   */
  public wPubilshFlg = 0;

  /**
   * 未掲載候補のみフラグ
   */
  public notPublishFlg = 0;

  /**
   * 商品案内用商品名
   */
  public guideGoodsName = '';

  /**
   * 他媒体対象フラグ
   */
  public otherMediumTypeFlg = 0;

  /**
   * ソート指定項目
   */
  public sortItem = '';

  /**
   * 昇順降順
   */
  public sortOrder = '';

  /**
   * 取得対象ページ
   */
  public page = 1;

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = this.DEFAULT_ORDER_GOODS_FLG;

  /*
   * 業態区分デイリー
   */
  public dutiesFormDailyList: string[] = [];

  /**
   * Ｐコードリスト
   */
  public pcodeList: string[] = [];
}
